import css from 'styled-jsx/css';


export default css`
  .wrapper-timer {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translate(-50%);
  }
  .time {
    background: var(--white);
    box-shadow: var(--shadow-light);
    width: 80px;
    height: 80px;
    font-size: 24px;
    font-weight: 600;
    color:var(--grey-dark);
  }
  .time span {
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
  }
  .d-n {
    display: none;
  }
`;
